import { Hyperlink } from '@strata/react-hyperlink';
import { InlineMessage } from '@strata/react-inline-message';
import paletteSrc from '@strata/strata-ui/source-of-truth/ui.color-palette.json';
import statusesSrc from '@strata/strata-ui/source-of-truth/ui.status.json';

import { ColorSwatch } from 'components/designSystem/colorPalette/ColorSwatch';
import { Columns } from 'components/shared/Columns';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const palette = [...paletteSrc, ...statusesSrc];
const paletteOrganized: (typeof palette)[] = [];
const colorCategories: string[] = [];

palette.forEach((color) => {
    const cat = color.category;

    // sort by category
    if (!colorCategories.includes(cat)) {
        colorCategories.push(cat);
        paletteOrganized.push(palette.filter((x) => x.category === cat));
    }
});

export const ColorPalette = () => (
    <div>
        <Page
            pageTitle="Color Palette"
            pageDescription="Color defines our brand and assists us in creating a consistent experience across our products."
            pageContent={
                <>
                    <div>
                        <p>
                            We work hard to ensure our palette complies with{' '}
                            <Hyperlink
                                linkText="Web Content Accessibility Guidelines"
                                navUrl="https://www.w3.org/TR/WCAG/"
                            />{' '}
                            AA standard for contrast ratios. To continue to support this effort,
                            please be sure to use the correct colors for text and backgrounds.
                        </p>
                        <div className="margin__top--medium margin__bottom--x-large">
                            <InlineMessage
                                wrapText
                                intent={InlineMessage.Intent.TIP}
                                title="Best Practice Tip"
                                label="Hex values should never used for colors within our scss files, variables should always be used."
                            />
                        </div>
                    </div>
                    {/* all colors */}
                    {paletteOrganized.map((categoryArr) => (
                        <Section
                            key={categoryArr[0].category}
                            title={categoryArr[0].category}
                            /* map through colors in this category */
                            contentArray={[
                                <Columns
                                    key="1"
                                    columns={Columns.ColumnNumber.TWO}
                                    content={categoryArr.map((color) => (
                                        <ColorSwatch key={color.variable_name} color={color} />
                                    ))}
                                />,
                            ]}
                        />
                    ))}
                </>
            }
        />
    </div>
);
